import _ from "lodash";

export function isUserInRole(desiredRoles, userRoles) {

  if (!Array.isArray(desiredRoles)) {
    desiredRoles = [desiredRoles];
  }

  const roles = userRoles;

  const idx = _.findIndex(desiredRoles, dr => {
    return roles.findIndex(r => r === dr) > -1;
  });

  return idx > -1;
}
